"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOAID = exports.getIDFV = exports.getQIMEI = exports.getAndroidId = exports.getQua2 = exports.historyBack = exports.getGuid = exports.openUrl = void 0;
var openUrl = function (url, isNewWindow) {
    if (isNewWindow === void 0) { isNewWindow = false; }
    return new Promise(function (resolve) {
        var _a, _b;
        if ((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.openUrl) {
            window.browser.app.openUrl(function () { return resolve(''); }, function () {
                window.location.href = url;
                return resolve('');
            }, { url: url, newWindow: "" + isNewWindow });
        }
        else {
            window.location.href = url;
            return resolve('');
        }
    });
};
exports.openUrl = openUrl;
var getGuid = function () { return new Promise(function (resolve, reject) {
    var _a, _b;
    if ((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.getBrowserParam) {
        window.browser.app.getBrowserParam(function (_a) {
            var guid = _a.guid;
            return resolve(guid);
        }, function (_a) {
            var code = _a.code;
            return reject(code);
        });
    }
    else {
        return resolve('');
    }
}); };
exports.getGuid = getGuid;
var historyBack = function () { return new Promise(function (resolve) {
    var _a, _b;
    if ((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.historyBack) {
        window.browser.app.historyBack();
        return resolve('');
    }
    window.history.back();
    return resolve('');
}); };
exports.historyBack = historyBack;
var getQua2 = function () { return new Promise(function (resolve) {
    var _a, _b;
    if ((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.getQua2) {
        window.browser.app.getQua2(function (qua) { return resolve(qua); });
    }
    else {
        return resolve('');
    }
}); };
exports.getQua2 = getQua2;
var getAndroidId = function () { return new Promise(function (resolve) {
    var _a, _b;
    if ((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getAndroidID) {
        window.browser.device.getAndroidID(function (_a) {
            var androidID = _a.androidID;
            return resolve(androidID);
        }, function () { return resolve(''); });
    }
    else {
        return resolve('');
    }
}); };
exports.getAndroidId = getAndroidId;
var getQIMEI = function () { return new Promise(function (resolve) {
    var _a, _b;
    if ((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getQIMEI) {
        window.browser.device.getQIMEI(function (_a) {
            var QIMEI = _a.QIMEI;
            return resolve(QIMEI);
        }, function () { return resolve(''); });
    }
    else {
        return resolve('');
    }
}); };
exports.getQIMEI = getQIMEI;
var getIDFV = function () { return new Promise(function (resolve) {
    var _a, _b;
    if ((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getIDFV) {
        window.browser.device.getIDFV(function (idfv) { return resolve(idfv); }, function () { return resolve(''); });
    }
    else {
        return resolve('');
    }
}); };
exports.getIDFV = getIDFV;
var getOAID = function () { return new Promise(function (resolve) {
    var _a, _b;
    if ((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getOAID) {
        window.browser.device.getOAID(function (oaid) { return resolve(oaid); }, function () { return resolve(''); });
    }
    else {
        return resolve('');
    }
}); };
exports.getOAID = getOAID;
//# sourceMappingURL=qb-jsapi.js.map